module.exports = __webpack_public_path__ + "img/googleplay.83cbefba.svg";